/* Disable select */
function disableSelect(elements) {
    elements.removeClass('filter-item--active filter-item--selected');
    elements.find('.filter-item__select').prop('disabled', true);
    elements.find('.filter-item__select').prop("selectedIndex", 0);
}
/* END Disable select */

export default (function ($) {

    var _instance = {};

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            var filterItemSelect = $('.filter-item__select'),
                filterBlockReset = $('.filter-block__reset'),
                $bookType = $(".js-book-type"),
                $book = $(".js-book"),
                $chapter = $(".js-chapter");

            if (filterItemSelect.length > 0) {
                filterItemSelect.on('change', function (e) {
                    e.preventDefault();

                    var $this = $(this);

                    setTimeout(function(){
                        var filterItems = $('.filter-item'),
                            filterItem = $this.closest('.filter-item'),
                            filterItemNext = filterItem.next(),
                            filterItemNextAll = filterItem.nextAll(),
                            selectValue = $this.val();

                        if (selectValue !== 'none') {
                            filterItem.addClass('filter-item--selected');
                            filterItemNext.addClass('filter-item--active');
                            filterItemNext.find('.filter-item__select').prop('disabled', false);
                        } else {
                            filterItem.removeClass('filter-item--selected');
                            disableSelect(filterItemNextAll);
                        }

                        changeFilterBlockTitle();

                        if (filterItems.last().hasClass('filter-item--selected')) {
                            // START Ajax success function
                            var bibleIndexResultsTemplate = wp.template('bible-index-results');
                            $('.bible-index__results .no-commentaries').hide();
                            $('.bible-index__results .results-wrap').hide();

                            $.get("/wp-json/bible-index/v1", {
                                book: $(".js-book").val(),
                                chapter: $chapter.val(),
                            })
                            .done(function (data) {
                                $('.bible-index__results .results-wrap').show();
                                $('.bible-index__results .results-wrap').html(bibleIndexResultsTemplate(data));
                            })
                            .fail(function () {
                                $('.bible-index__results .no-commentaries').show();
                            })
                            .always(function () {
                                $('.page-template-template-bible-index').addClass('page-template-template-bible-index--show');
                            });
                        }
                    }, 0);
                })
            }

            if ($bookType.length > 0) {
                $(".js-book-type").on("change", function () {
                    $book.val("none");
                    $book.closest(".filter-item").removeClass("filter-item--selected");
                    $chapter.val("none");
                    disableSelect($chapter.closest(".filter-item"));
                    $chapter.closest(".filter-item").removeClass("filter-item--selected");
                    var value = $(this).val();
                    $(".js-book-option").hide();
                    $(".js-" + value + "-book").show();
                    $('.page-template-template-bible-index').removeClass('page-template-template-bible-index--show');
                });
            }


            if ($book.length > 0) {
                $book.on("change", function () {
                    $chapter.val("none");
                    $chapter.closest(".filter-item").removeClass("filter-item--selected");

                    var selected_book_type = $(".js-book-type option:selected").val();
                    var selected_book = $(".js-book option:selected").text();

                    var chapterOptions;
                    if(selected_book_type === "old-testament") {
                        chapterOptions = window.old_testament_books[selected_book];
                    } else {
                        chapterOptions = window.new_testament_books[selected_book];
                    }

                    $chapter.find(".js-chapter-option").remove();
                    $.each(chapterOptions, function( key, value ) {
                        $chapter.append('<option class="js-chapter-option" value="' + key + '">' + global.chapter + key + '</option>');
                    });
                    $('.page-template-template-bible-index').removeClass('page-template-template-bible-index--show');
                });
            }

            if (filterBlockReset.length > 0) {
                filterBlockReset.on('click', function (e) {
                    e.preventDefault();
                    var filterItems = $('.filter-item');
                    filterItems.removeClass('filter-item--selected');
                    $('.filter-item:not(:first)').removeClass('filter-item--active');
                    $('.filter-item:not(:first)').find('.filter-item__select').prop('disabled', true);
                    filterItems.find('.filter-item__select').prop("selectedIndex", 0);
                    changeFilterBlockTitle();
                    $('.page-template-template-bible-index').removeClass('page-template-template-bible-index--show');
                })
            }

            /* Change filter block title */
            function changeFilterBlockTitle() {
                var filterItemTitle = $('.filter-item--active').last().find('.filter-item__title').text().split('-');
                $('.filter-block__title').html('Step ' + filterItemTitle[0].trim() + ' - Choose a ' + filterItemTitle[1].toLowerCase().trim() + ':');
            }

            /* END Change filter block title */
        })
    };

    return _instance;

})(jQuery)